import { RouteRecordRaw } from "vue-router";

import { ROLES_AND_PERMISSION_ON_ROUTES } from "@/core/configs/rolesAndPermissionsMappingOnRoutes";
import { PATH } from "@/core/constants/path";

const routes: Array<RouteRecordRaw> = [
  {
    path: PATH.MY_TEAM,
    name: "salesMyTeam",
    meta: {
      roles: ROLES_AND_PERMISSION_ON_ROUTES.SALES_MY_TEAM.ROLES,
      permissions: ROLES_AND_PERMISSION_ON_ROUTES.SALES_MY_TEAM.PERMISSIONS,
    },
    component: () => import("@/modules/Sales/views/SalesMyTeamPage.vue"),
  },
];

export default routes;
